var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResidential(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 144,
    height: 177,
    viewBox: "0 0 144 177",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-5{fill:none}.cls-2,.cls-4{fill:#4b4b4b}.cls-4,.cls-5{stroke:#4b4b4b}.cls-5{stroke-miterlimit:10;stroke-width:2.268px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Residential",
    transform: "translate(0 -.461)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_340",
    fill: "none",
    d: "M0 0H144V177H0z",
    transform: "translate(0 .461)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_346",
    transform: "translate(26.026 52.949)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2202",
    d: "M236.739 229.487h-87.83a2.405 2.405 0 0 1-2.4-2.432v-3.962a2.408 2.408 0 0 1 2.4-2.412h2.017V131.6a4.311 4.311 0 0 1 3.042-4.158l26.643-7.8a4.272 4.272 0 0 1 5.412 4.176v96.729h1.75v-110.03a4.829 4.829 0 0 1 4.8-4.851h25.487a4.815 4.815 0 0 1 4.8 4.863v43.058h7.055a4.821 4.821 0 0 1 4.806 4.862v62.231h2.026a2.417 2.417 0 0 1 2.393 2.437v3.958a2.41 2.41 0 0 1-2.4 2.412zm-87.69-2.42zm0-3.843v3.72H236.6v-3.72h-4.419V158.44a2.28 2.28 0 0 0-2.26-2.309h-9.6v-45.614a2.274 2.274 0 0 0-2.252-2.307h-25.49a2.28 2.28 0 0 0-2.263 2.287V223.1h-6.837v-99.29a1.73 1.73 0 0 0-1.705-1.77 1.574 1.574 0 0 0-.477.061l-26.6 7.787a1.759 1.759 0 0 0-1.228 1.7v91.639zm87.551-.124zm-25.173-.534h-9.477V211.93a2.284 2.284 0 0 1 2.264-2.3h7.206zm-6.929-2.543h4.386v-7.851H204.5zm17.32 2.534h-9.473v-12.936h8.452v.5a2.29 2.29 0 0 1 1.021 1.91zm-6.93-2.543h4.387v-7.588l-1.021.341v-.6h-3.365z",
    className: "cls-2",
    transform: "translate(-146.505 -105.666)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_345",
    transform: "translate(6.108 114.945)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_64",
    fill: "#fff",
    d: "M0 0L80.769 0",
    transform: "translate(0 1.272)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_298",
    d: "M0 0H80.769V2.543H0z",
    className: "cls-2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2203",
    d: "M178.5 140.593h-15.983a1.585 1.585 0 0 0-1.067.384l-.109.1h-.441v3.39a1.409 1.409 0 0 0 1.5 1.373h16.1a1.409 1.409 0 0 0 1.5-1.373v-2.5a1.407 1.407 0 0 0-1.5-1.374zm-.282 3.463h-15.539v-1.2h.118v-.482h15.425z",
    className: "cls-4",
    transform: "translate(-147.981 -109.248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2204",
    d: "M178.5 152.17h-15.983a1.574 1.574 0 0 0-1.071.389l-.108.1h-.441v3.392a1.409 1.409 0 0 0 1.5 1.372H178.5a1.409 1.409 0 0 0 1.5-1.372v-2.51a1.409 1.409 0 0 0-1.5-1.371zm-.282 3.474h-15.539v-1.216h.118v-.477h15.425z",
    className: "cls-4",
    transform: "translate(-147.981 -110.436)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2205",
    d: "M178.5 163.757h-15.983a1.579 1.579 0 0 0-1.076.392l-.107.1-.436.006v3.377A1.409 1.409 0 0 0 162.4 169h16.1a1.409 1.409 0 0 0 1.5-1.373v-2.5a1.409 1.409 0 0 0-1.5-1.37zm-.282 3.466h-15.539v-1.214h.118v-.469h15.425z",
    className: "cls-4",
    transform: "translate(-147.981 -111.624)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2206",
    d: "M178.5 175.34h-15.983a1.579 1.579 0 0 0-1.076.392l-.107.1-.436.006v3.377a1.409 1.409 0 0 0 1.5 1.373H178.5a1.409 1.409 0 0 0 1.5-1.373v-2.5a1.409 1.409 0 0 0-1.5-1.375zm-.282 3.466h-15.539v-1.214h.118v-.469h15.425z",
    className: "cls-4",
    transform: "translate(-147.981 -112.812)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2207",
    d: "M178.5 186.923h-15.983a1.579 1.579 0 0 0-1.076.392l-.107.1-.436.006v3.379a1.409 1.409 0 0 0 1.5 1.373H178.5a1.409 1.409 0 0 0 1.5-1.373v-2.5a1.409 1.409 0 0 0-1.5-1.377zm-.282 3.466h-15.539v-1.214h.118v-.475h15.425z",
    className: "cls-4",
    transform: "translate(-147.981 -114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2208",
    d: "M178.5 198.506h-15.983a1.579 1.579 0 0 0-1.076.392l-.107.1-.434.002v3.377a1.409 1.409 0 0 0 1.5 1.373h16.1a1.409 1.409 0 0 0 1.5-1.373v-2.5a1.409 1.409 0 0 0-1.5-1.371zm-.282 3.466h-15.539v-1.214h.118v-.469h15.425z",
    className: "cls-4",
    transform: "translate(-147.981 -115.188)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2209",
    d: "M178.5 210.089h-15.983a1.577 1.577 0 0 0-1.065.384l-.109.1h-.443v3.391a1.4 1.4 0 0 0 1.5 1.376h16.1a1.409 1.409 0 0 0 1.5-1.373v-2.5a1.409 1.409 0 0 0-1.5-1.378zm-.282 3.466h-15.539v-1.2h.118v-.488h15.425z",
    className: "cls-4",
    transform: "translate(-147.981 -116.376)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2210",
    d: "M178.5 221.672h-15.983a1.581 1.581 0 0 0-1.071.388l-.109.1h-.437v3.384a1.4 1.4 0 0 0 1.5 1.376h16.1a1.409 1.409 0 0 0 1.5-1.373v-2.5a1.409 1.409 0 0 0-1.5-1.375zm-.282 3.466h-15.539v-1.685h15.543z",
    className: "cls-4",
    transform: "translate(-147.981 -117.564)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_299",
    width: 8.077,
    height: 8.077,
    className: "cls-5",
    rx: 1,
    transform: "translate(48.821 6.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_300",
    width: 8.077,
    height: 8.077,
    className: "cls-5",
    rx: 1,
    transform: "translate(48.821 19.137)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_301",
    width: 8.077,
    height: 8.077,
    className: "cls-5",
    rx: 1,
    transform: "translate(48.821 31.324)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_302",
    width: 8.077,
    height: 8.077,
    className: "cls-5",
    rx: 1,
    transform: "translate(48.821 43.511)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_303",
    width: 8.077,
    height: 8.077,
    className: "cls-5",
    rx: 1,
    transform: "translate(48.821 55.698)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_304",
    width: 8.077,
    height: 8.077,
    className: "cls-5",
    rx: 1,
    transform: "translate(48.821 67.885)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_305",
    width: 8.077,
    height: 8.077,
    className: "cls-5",
    rx: 1,
    transform: "translate(48.821 80.073)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_306",
    width: 8.077,
    height: 8.077,
    className: "cls-5",
    rx: 1,
    transform: "translate(48.821 92.26)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_307",
    width: 8.077,
    height: 8.077,
    className: "cls-5",
    rx: 1,
    transform: "translate(60.488 6.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_308",
    width: 8.077,
    height: 8.077,
    className: "cls-5",
    rx: 1,
    transform: "translate(60.488 19.137)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_309",
    width: 8.077,
    height: 8.077,
    className: "cls-5",
    rx: 1,
    transform: "translate(60.488 31.324)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_310",
    width: 8.077,
    height: 8.077,
    className: "cls-5",
    rx: 1,
    transform: "translate(60.488 43.511)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_311",
    width: 8.077,
    height: 8.077,
    className: "cls-5",
    rx: 1,
    transform: "translate(60.488 55.698)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_312",
    width: 8.077,
    height: 8.077,
    className: "cls-5",
    rx: 1,
    transform: "translate(60.488 67.885)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_313",
    width: 8.077,
    height: 8.077,
    className: "cls-5",
    rx: 1,
    transform: "translate(60.488 80.073)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_314",
    width: 8.077,
    height: 8.077,
    className: "cls-5",
    rx: 1,
    transform: "translate(60.488 92.26)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_315",
    width: 8.077,
    height: 8.077,
    className: "cls-5",
    rx: 1,
    transform: "translate(72.154 55.698)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_316",
    width: 8.077,
    height: 8.077,
    className: "cls-5",
    rx: 1,
    transform: "translate(72.154 67.885)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_317",
    width: 8.077,
    height: 8.077,
    className: "cls-5",
    rx: 1,
    transform: "translate(72.154 80.073)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_318",
    width: 8.077,
    height: 8.077,
    className: "cls-5",
    rx: 1,
    transform: "translate(72.154 92.26)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResidential);
export default __webpack_public_path__ + "static/media/residential.cd60b23538ae358b2e4539c850d2b196.svg";
export { ForwardRef as ReactComponent };